export default {
      id: "color_health-usage",
      viewBox: "0 0 75 75",
      url: __webpack_public_path__ + "sprite.svg#color_health",
      toString: function () {
        return this.url;
      }
    }